export const MAIN_PAGE_NAV_LABEL = 'All Sessions';
